/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//create react functions for customer testimonials make the front end for the customer testimonials really nice
//and backend fuctions in node.js

//ran this thru claudes code refactoring tool

// suggest improvements for this component
// give me the entire code to copy

// redesign this component to look more elegant and polished and accents
// use tailwind css in the className directive 
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation
//  (e.g. sellerPrimaryColor1 + sellerColorSuffixDark) for tints, never hardcode colors."
// sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
// give me the entire code to copy


// one of the list items is appearing twice in the sellerArrEventTypes drop down list, please fix that issue


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaRegThumbsUp } from 'react-icons/fa';
import { add_customer_testimonial, messageClear } from '../../store/reducers/customerTestimonialReducer';
import GetSellerConfig from '../GetSellerConfig';
import toast from 'react-hot-toast';
import config from '../../config';

const INITIAL_FORM_STATE = {
    customerDisplayName: '',
    rating: '',
    review: '',
    eventType: '',
};

// Reusable styled input base class
const inputBase =
    'w-full px-4 py-3 rounded-xl text-sm outline-none transition-all duration-200 border bg-white/60 backdrop-blur-sm placeholder:text-gray-400 focus:ring-2 focus:ring-offset-0';

const CustomerTestimonialsDashboard = () => {
    const sellerFrontEndURL = config.STR_FRONTEND_URL;
    
    const { errorMessage, successMessage } = useSelector(
        (state) => state.customerTestimonial
    );

    const {sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2, sellerColorSuffixDark, 
        sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor, sellerEventTypeList
    } = GetSellerConfig();
    //console.log('sellerEventTypeList\n', sellerEventTypeList)
    
    const sellerArrEventTypes = [
        ...new Set(
            (sellerEventTypeList ?? '')
                .split(';')
                .map((et) => et.trim())
                .filter((et) => et.length > 0)
        ),
    ];
    //console.log('sellerArrEventTypes ', sellerArrEventTypes)
    
    const dispatch = useDispatch();
    const arrRatings = [2, 2.5, 3, 3.5, 4, 4.5, 5];

    const [formState, setFormState] = useState({
        ...INITIAL_FORM_STATE,
        sellerId,
        webSiteOrigin: sellerFrontEndURL,
    });

    const resetForm = () => setFormState((prev) => ({ ...prev, ...INITIAL_FORM_STATE }));

    const inputHandle = (e) =>
        setFormState((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(add_customer_testimonial(formState));
        resetForm();
    };

    useEffect(() => {
        if (successMessage) { toast.success(successMessage); dispatch(messageClear()); }
        if (errorMessage)   { toast.error(errorMessage);   dispatch(messageClear()); }
    }, [successMessage, errorMessage, dispatch]);

    // ─── Derived color tokens ──────────────────────────────────────────────────
    const colorLight    = sellerPrimaryColor1 + sellerColorSuffixLight;   // accentBg very light tint
    const colorMedium   = sellerPrimaryColor1 + sellerColorSuffixMedium;  // accentMid medium tint
    const colorDark     = sellerPrimaryColor1 + sellerColorSuffixDark;    // accentDark dark tint / border
    const colorBg       = sellerComponentBackgroundColor;
    //const ringColor     = sellerPrimaryColor1 + sellerColorSuffixMedium;

    return (
        <div
            className="bg-white relative rounded-2xl overflow-hidden">
            {/* ── Outer card
                w-full max-w-2xl mx-auto  
            fontFamily: "'DM Sans', sans-serif"
                ─────────────────────────────────────────────────── */}
            <div
                className="rounded-2xl p-4 border overflow-hidden"
                style={{
                    backgroundColor: colorLight || '#ffffff',
                    borderColor: colorDark,
                }}>
                {/* ── Header strip ───────────────────────────────────────────── */}
                <div
                    className="px-0 py-0 flex items-center gap-1"
                    style={{ }}>
                    <span
                        className="flex items-center justify-center w-10 h-10 rounded-xl shadow-sm"
                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                        <FaRegThumbsUp size={34} />
                    </span>

                    <div>
                        <h2
                            className="text-lg font-semibold tracking-tight leading-none"
                            style={{ color: sellerPrimaryColor1 }}>
                            Share Your Experience
                        </h2>
                        <p className="text-xs mt-0.5" style={{ color: colorDark }}>
                            Your feedback means everything to us
                        </p>
                    </div>
                </div>

                {/* ── Thin accent line ───────────────────────────────────────── */}
                <div className="hidden h-px w-full" style={{ backgroundColor: colorDark }} />

                {/* ── Body ───────────────────────────────────────────────────── */}
                <div className="px-2 py-6">
                    {/* Social proof quotes */}
                    <div
                        className="mb-6 rounded-xl p-3 space-y-1.5"
                        style={{ backgroundColor: colorLight }}>
                        {[
                            { quote: "The food was absolutely delicious! I can't wait to order again.", name: 'Sarah M.' },
                            { quote: "Fantastic menu options and top-notch quality every single time.", name: 'Emily R.' },
                        ].map(({ quote, name }) => (
                            <blockquote
                                key={name}
                                className="flex gap-3 items-start text-sm"
                                style={{ color: sellerPrimaryColor1 }}>
                                {/* Decorative quotemark */}
                                <span
                                    className="text-2xl leading-none select-none mt-[-4px]"
                                    style={{ color: sellerPrimaryColor1 }}
                                    aria-hidden>
                                    "
                                </span>
                                <span style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                    <span className="">{quote}</span>{' '}
                                    <span className="font-semibold text-xs">— {name}</span>
                                </span>
                                <span
                                    className="text-2xl leading-none select-none mt-[-4px]"
                                    style={{ color: sellerPrimaryColor1 }}
                                    aria-hidden>
                                    "
                                </span>
                            </blockquote>
                        ))}
                    </div>

                    {/* Divider with label */}
                    <div className="flex items-center gap-3 mb-4">
                        <div className="flex-1 h-px" style={{ backgroundColor: colorDark }} />
                        <span className="text-xs font-medium tracking-widest uppercase" style={{ color: colorDark }}>
                            Your Testimonial
                        </span>
                        <div className="flex-1 h-px" style={{ backgroundColor: colorDark }} />
                    </div>

                    {/* ── Form ───────────────────────────────────────────────── */}
                    <form onSubmit={handleSubmit} className="space-y-4">

                        {/* Display name */}
                        <input
                            required
                            type="text"
                            name="customerDisplayName"
                            value={formState.customerDisplayName}
                            onChange={inputHandle}
                            placeholder="First Name & Last Initial"
                            className={inputBase}
                            style={{
                                borderColor: colorDark,
                                color: sellerPrimaryColor1,
                                '--tw-ring-color': colorMedium,
                            }}
                        />

                        {/* Rating + Event in a 2-col grid */}
                        <div className="grid grid-cols-2 gap-4">
                            <div className="relative">
                                <select
                                    required
                                    name="rating"
                                    value={formState.rating}
                                    onChange={inputHandle}
                                    className={inputBase + ' appearance-none pr-8 cursor-pointer'}
                                    style={{
                                        borderColor: colorDark,
                                        color: formState.rating ? sellerPrimaryColor1 : '#9ca3af',
                                        '--tw-ring-color': colorMedium,
                                    }}>
                                    <option value="" disabled>Rating</option>
                                    {arrRatings.map((r) => (
                                        <option key={r} value={r} style={{ color: sellerPrimaryColor1 }}>
                                            {r} ★
                                        </option>
                                    ))}
                                </select>
                                {/* Chevron */}
                                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 
                                text-xl">▾</span>
                            </div>

                            <div className="relative">
                                <select
                                    required
                                    name="eventType"
                                    value={formState.eventType}
                                    onChange={inputHandle}
                                    className={inputBase + ' appearance-none pr-8 cursor-pointer'}
                                    style={{
                                        borderColor: colorDark,
                                        color: formState.eventType ? sellerPrimaryColor1 : '#9ca3af',
                                        '--tw-ring-color': colorMedium,
                                    }}>
                                    <option value="" disabled>Event Type</option>
                                    {sellerArrEventTypes.map((et) => (
                                        <option key={et} value={et} style={{ color: sellerPrimaryColor1 }}>
                                            {et}
                                        </option>
                                    ))}
                                </select>
                                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 
                                text-xl">▾</span>
                            </div>
                        </div>

                        {/* Textarea */}
                        <textarea
                            required
                            name="review"
                            value={formState.review}
                            onChange={inputHandle}
                            placeholder="Tell us about your experience…"
                            rows={5}
                            className={inputBase + ' resize-none leading-relaxed'}
                            style={{
                                borderColor: colorDark,
                                color: sellerPrimaryColor1,
                                '--tw-ring-color': colorMedium,
                            }}
                        />

                        {/* Submit */}
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                className="
                                    relative inline-flex items-center gap-2
                                    px-7 py-3 rounded-xl text-sm font-semibold text-white
                                    shadow-md transition-all duration-200
                                    hover:shadow-lg hover:scale-[1.02] active:scale-[0.98]
                                    focus:outline-none focus:ring-2 focus:ring-offset-2
                                "
                                style={{
                                    backgroundColor: sellerPrimaryColor1,
                                    '--tw-ring-color': colorMedium,
                                    '--tw-ring-offset-color': colorBg || '#fff',
                                }}>
                                <FaRegThumbsUp className="text-base" />
                                Submit Testimonial
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CustomerTestimonialsDashboard;





//refatored
// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { FaRegThumbsUp } from 'react-icons/fa';
// import { add_customer_testimonial, messageClear } from '../../store/reducers/customerTestimonialReducer';

// import GetSellerConfig from '../GetSellerConfig';
// import toast from 'react-hot-toast';
// import config from '../../config';

// const INITIAL_FORM_STATE = {
//     customerDisplayName: '',
//     rating: '',
//     review: '',
//     eventType: '',
// };

// const CustomerTestimonialsDashboard = () => {
//     const sellerFrontEndURL = config.STR_FRONTEND_URL;
//     const sellerEventTypes = config.STR_ARR_FRONTEND_EVENT_TYPES;

//     const { customerTestimonials, errorMessage, successMessage } = useSelector(
//         (state) => state.customerTestimonial
//     );
//     // const { seller } = useSelector((state) => state.seller);

//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//     } = GetSellerConfig();

//     const dispatch = useDispatch();

//     const arrRatings = [2, 2.5, 3, 3.5, 4, 4.5, 5];

//     const [formState, setFormState] = useState({
//         ...INITIAL_FORM_STATE,
//         sellerId: sellerId, //seller._id,
//         webSiteOrigin: sellerFrontEndURL,
//     });

//     const resetForm = () => {
//         setFormState((prev) => ({
//             ...prev,
//             ...INITIAL_FORM_STATE,
//         }));
//     };

//     const inputHandle = (e) => {
//         setFormState((prev) => ({
//             ...prev,
//             [e.target.name]: e.target.value,
//         }));
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         dispatch(add_customer_testimonial(formState));
//         resetForm();
//     };

//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch]);

//     return (
//         <div>
//             <div
//                 className="border p-4 rounded-md"
//                 style={{
//                     backgroundColor: sellerSecondaryColor1,
//                     color: sellerPrimaryColor1,
//                     borderColor: sellerPrimaryColor1,
//                 }}
//             >
//                 <div className="flex items-center gap-2 mb-4">
//                     <FaRegThumbsUp className="text-[32px]" />
//                     <h2 className="text-xl font-bold">Customer Testimonials</h2>
//                 </div>

//                 <div className="mb-4">
//                     <p className="mb-2">
//                         We value our customers' feedback and strive to provide the best experience
//                         possible.
//                         <br />
//                         Here are some testimonials from our satisfied customers:
//                     </p>
//                     <ul className="list-disc list-inside mb-4">
//                         <li>"The food was absolutely delicious! I can't wait to order again." - Sarah M.</li>
//                         <li>"The menu options are fantastic, and the quality is top-notch." - Emily R.</li>
//                     </ul>
//                     <p>Please take a moment to give us your honest feedback.</p>
//                 </div>

//                 <form onSubmit={handleSubmit} className="flex flex-col gap-2">
//                     <input
//                         required
//                         type="text"
//                         name="customerDisplayName"
//                         value={formState.customerDisplayName}
//                         onChange={inputHandle}
//                         placeholder="Display Name (First Name & Last Initial)"
//                         className="w-full max-w-md px-3 py-2 border rounded-md"
//                     />

//                     <div className="flex flex-wrap gap-2">
//                         <select
//                             required
//                             name="rating"
//                             value={formState.rating}
//                             onChange={inputHandle}
//                             className="px-3 py-2 border rounded-md"
//                         >
//                             <option value="" disabled>
//                                 Select Rating
//                             </option>
//                             {arrRatings.map((rating) => (
//                                 <option key={rating} value={rating}>
//                                     {rating} Stars
//                                 </option>
//                             ))}
//                         </select>

//                         <select
//                             required
//                             name="eventType"
//                             value={formState.eventType}
//                             onChange={inputHandle}
//                             className="px-3 py-2 border rounded-md"
//                         >
//                             <option value="" disabled>
//                                 Select Event Type
//                             </option>
//                             {sellerEventTypes.map((eventType) => (
//                                 <option key={eventType} value={eventType}>
//                                     {eventType}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>

//                     <textarea
//                         required
//                         name="review"
//                         value={formState.review}
//                         onChange={inputHandle}
//                         placeholder="Your Testimonial"
//                         className="w-full max-w-md h-40 px-3 py-2 border rounded-md text-sm resize-y"
//                     />

//                     <div>
//                         <button
//                             type="submit"
//                             className="px-4 py-2 text-white rounded-md transition-opacity hover:opacity-90"
//                             style={{ backgroundColor: sellerPrimaryColor1 }}
//                         >
//                             Submit Testimonial
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default CustomerTestimonialsDashboard;



//my original code
// import React, { useEffect, useState }  from 'react';
// import {  useNavigate, Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaRegThumbsUp } from "react-icons/fa";

// import { add_customer_testimonial, messageClear } from '../../store/reducers/customerTestimonialReducer';
// import toast from 'react-hot-toast';

// import config from '../../config';

// const CustomerTestimonialsDashboard = () => {
//     const sellerFrontEndURL = config.STR_FRONTEND_URL
//     const sellerEnvironment = config.STR_ENVIRONMENT
//     const sellerEventTypes = config.STR_ARR_FRONTEND_EVENT_TYPES

//     const { userInfo } = useSelector(state => state.auth)
//     const { depositProduct } = useSelector(state => state.home)
//     const { customerTestimonials, errorMessage, successMessage } = useSelector(state => state.customerTestimonial);
        
//     const { seller } = useSelector(state => state.seller)
//     //console.log('customerTestimonials ', customerTestimonials)
    
//     //console.log('seller ', seller)
    
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerPrimaryColor2 =  seller?.frontEndPrimaryColor2
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1
//     const sellerPhoneNumber = seller?.phoneNumber
//     const sellerEmailAddress = seller?.emailAddress

//     const sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller?.isVisibleSiteChat === 'Show' ? true : false
    
//     const navigate = useNavigate();
//     const dispatch = useDispatch()
//     const arrRatings = [2, 2.5, 3, 3.5, 4, 4.5, 5]
    
//     const [mySellerId, setMySellerId] = useState(seller._id)
//     const [state, setState] = useState({
//         sellerId: mySellerId, webSiteOrigin: sellerFrontEndURL, 
//         customerDisplayName: '', rating: '', review: '', eventType: ''
//     })
    
//     const add_customer_testimonial_local = (e) => {
//         e.preventDefault()
//         console.log('state ', state)
//         dispatch(add_customer_testimonial(state))
//         state.customerDisplayName = ''
//         state.rating = ''
//         state.review = ''
//         state.eventType = ''
//     }

//     const inputHandle = (e) => {
//         //e.preventDefault()
//         //e.stopPropagation();
//         setState({
//             ...state,   
//             [e.target.name]: e.target.value
//         })
//         // console.log(state) 
//         //console.log(e.target.name) 
//         //console.log(e.target.value) 
//     }

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             //send newletter
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     return (
//         <div>
//             <div className='border p-4 rounded-md'
//                 style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                 <div className='flex items-center gap-2 mb-4'>
//                     <FaRegThumbsUp className='text-[32px]'/>
//                     <h2 className='text-xl font-bold'>Customer Testimonials</h2>
//                 </div>
//                 <div className=''>
//                     <p className='mb-2'>We value our customers' feedback and strive to provide the best experience possible. 
//                     <br/>Here are some testimonials from our satisfied customers:</p>
//                     <ul className='list-disc list-inside mb-4'>
//                         <li>"The food was absolutely delicious! I can't wait to order again." - Sarah M.</li>
//                         <li>"The menu options are fantastic, and the quality is top-notch." - Emily R.</li>
//                     </ul>
//                     <p>Please take a moment to give us your honest feedback</p>  
//                 </div>
//                 <form onSubmit={add_customer_testimonial_local}>
//                     <div className=''>
//                         <div className='border-none border-black'> 
//                             <input required type='text' name='customerDisplayName' value={state.customerDisplayName} 
//                                 onChange={inputHandle} placeholder='Display Name First Name And Last Initial' 
//                                 className='w-[400px] sm:w-[200px] px-2 py-1 m-0.5 border rounded-md'/>
//                         </div>
//                     <div className='border-none border-black'>
//                         <select required name='rating' value={state.rating} onChange={inputHandle} 
//                             className='w-[200px] px-2 py-1 m-0.5 border rounded-md'>
//                             <option value='' disabled>Select Rating</option>
//                             {arrRatings.map((rating) => (
//                                 <option key={rating} value={rating}>{rating} Stars</option>
//                             ))}
//                         </select>
//                         <select required name='eventType' value={state.eventType} onChange={inputHandle} 
//                             className='w-[200px] px-2 py-1 m-0.5 border rounded-md'>
//                             <option value='' disabled>Select Event Type</option>
//                             {sellerEventTypes.map((eventType) => (
//                                 <option key={eventType} value={eventType}>{eventType}</option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>
//                 <div>
//                     <textarea required name='review' value={state.review} onChange={inputHandle} placeholder='Your Testimonial' 
//                         className='w-[400px] h-[160px] sm:w-[200px] m-0.5 border text-[12px]'/>
//                 </div>
//                 <div>
//                     <button type='submit' 
//                         className='px-4 py-2 bg-green-500 text-white rounded-md'
//                         style={{backgroundColor:sellerPrimaryColor1}}>
//                         Submit Testimonial
//                     </button>
//                 </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default CustomerTestimonialsDashboard;






